import {Operation} from "../models/Operation";
import {API, graphqlOperation} from "aws-amplify";
import {addJourneyMapOperation, deleteJourneyMapOperations} from "./mutations";
import {
    AddJourneyMapOperationMutation,
    GetJourneyMapOperationQuery,
    JourneyMapOperation,
    ListOperationsQuery,
} from "../API";
import {getJourneyMapOperation, listOperations} from "./queries";
import {debug_log} from "../utils/debug";

export async function storeJourneyMapOperationsEx(mapId: string, op: Operation): Promise<JourneyMapOperation> {
    const res = await API.graphql(graphqlOperation(
        addJourneyMapOperation, {
            mapId: mapId,
            type: op.type,
            data: JSON.stringify(op.data)
        }
    )) as { data: AddJourneyMapOperationMutation };

    if (!res.data || !res.data.addJourneyMapOperation) {
        debug_log(res);
        throw new Error('send op failed');
    }

    return res.data.addJourneyMapOperation;
}


export async function fetchJourneyMapOperationsEx(mapId: string, nextToken?: string): Promise<JourneyMapOperation[]> {
    let operations: JourneyMapOperation[] = [];

    const res = await API.graphql(graphqlOperation(listOperations, {
        mapId: mapId,
        nextToken: nextToken
    })) as { data: ListOperationsQuery };

    if (res.data.listOperations) {
        res.data.listOperations.items?.forEach((op) => {
            if (op) {
                operations.push(op);
            }
        });

        if (res.data.listOperations.nextToken) {
            operations = operations.concat(await fetchJourneyMapOperationsEx(mapId, res.data.listOperations.nextToken));
        }
    }

    return operations;
}


export async function fetchJourneyMapOperation(mapId: string, seq: number): Promise<{
    mapId: string,
    seq: number,
    owner: string,
    type: string,
    data: string,
    createdAt: string,
}> {
    const res = await API.graphql(graphqlOperation(
        getJourneyMapOperation, {
            mapId: mapId,
            seq: seq,
        }
    )) as { data: GetJourneyMapOperationQuery };

    if (!res.data || !res.data.getJourneyMapOperation) {
        debug_log(res);
        throw new Error('fetchJourneyMapOperation failed');
    }

    return res.data.getJourneyMapOperation;
}


export async function fetchJourneyMapOperationsEx2(mapId: string, begin_seq: number, end_seq?: number, nextToken?: string): Promise<JourneyMapOperation[]> {
    let operations: JourneyMapOperation[] = [];

    const res = await API.graphql(graphqlOperation(listOperations, {
        mapId: mapId,
        beginSeq: begin_seq,
        nextToken: nextToken
    })) as { data: ListOperationsQuery };

    if (res.data.listOperations) {
        res.data.listOperations.items?.forEach((op) => {
            if (op) {
                operations.push(op);
            }
        });

        if (res.data.listOperations.nextToken) {
            operations = operations.concat(await fetchJourneyMapOperationsEx2(mapId, begin_seq, end_seq, res.data.listOperations.nextToken));
        }
    }

    if (end_seq === undefined) {
        return operations;
    } else {
        return operations.filter(op => begin_seq <= op.seq && op.seq < end_seq);
    }
}


export async function removeOperationEx(ops: JourneyMapOperation[]) {
    if (ops.length === 0) {
        throw new Error('ops must not empty');
    }

    debug_log("remove operation", ops);

    const map_id = ops[0].mapId;
    const seq_list = ops.map(op => op.seq);

    await API.graphql(graphqlOperation(
        deleteJourneyMapOperations, {mapId: map_id, seqList: seq_list})
    );
}
